import React, { useState, useEffect } from "react";
import { NavLink, useHistory } from "react-router-dom";
import {
	SettingsUser,
	SettingsCart,
	SettingsCreate,
	SettingsCrypto,
	SettingsDesign,
	SettingsIdentity,
	SettingsGatewayFees,
	SettingsManagers,
	SettingsCurrencies,
	SettingsPayments,
	SettingsShop,
	SettingsTax,
	SettingsShopify,
	SettingsSubs,
	SettingsFraud,
	SettingsSecurity,
	SettingsNotification,
} from "../../dashboard/sidebar/icons/icons/icons";
import { CustomersAffiliate } from "../../dashboard/sidebar/icons/icons";
import ClosePage from "../../../screens/products/product/screens/components/save-close";

import "./index.scss";


const Sidebar = ({ formRef }) => {

	const [closeConfirmModal, setShowConfirmModal] = useState(false);
	const history = useHistory();
	const isManager = history.location.pathname.includes("settings/shop/managers");
	const isGatewayFees = history.location.pathname.includes("settings/shop/gateway-fees");
	const isShopify = history.location.pathname.includes("/settings/shop/shopify");

	const onChangeRoute = (to, e) => {
		if(isManager || isGatewayFees) {
			return;
		}

		e.preventDefault();

		if(formRef && formRef.current) {
			if(formRef.current.dirty) {
				setShowConfirmModal(to)
			} else {
				history.push(to);
			}
		}
	}

	useEffect(() => {
		setShowConfirmModal(false);
	}, [history.location.pathname])

	return <div className="settings-sidebar-wrapper">

		<div className="settings-sidebar">
			<div className="settings-sidebar-title">User</div>
			<div className="settings-sidebar-body">
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/general")} to="/settings/general" id="settings-user-general"><SettingsUser /><span>General</span> </NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/personal")}  to="/settings/personal" id="settings-user-personal"><SettingsIdentity /><span>Identity</span></NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/security")}  to="/settings/security" id="settings-user-security"><SettingsSecurity /><span>Security</span></NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/notifications")}  to="/settings/notifications" id="settings-user-notifications"><SettingsNotification /><span>Notifications</span></NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/create/shop")}  to="/settings/create/shop" id="settings-user-shop"><SettingsCreate /><span>Create Shop</span></NavLink>
			</div>
		</div>

		<div className="settings-sidebar">
			<div className="settings-sidebar-title">Shop</div>
			<div className="settings-sidebar-body">
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/shop/general")}  to="/settings/shop/general" id="settings-shop-general"><SettingsShop /><span>General</span></NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/shop/payments")}  to="/settings/shop/payments" id="settings-shop-payments"><SettingsPayments /><span>Payments</span></NavLink>				{/* Temporarily hidden - old crypto system is deprecated and being replaced with Cryptomus */}
				{/* <NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/shop/crypto")}  to="/settings/shop/crypto" id="settings-shop-crypto"><SettingsCrypto /><span>Cryptocurrencies</span></NavLink> */}
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/shop/tax")}  to="/settings/shop/tax" id="settings-shop-tax"><SettingsTax /><span>Tax</span></NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/shop/shopify")}  to="/settings/shop/shopify" id="settings-shop-shopify"><SettingsShopify isActive={isShopify} /><span>Shopify</span></NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/shop/currencies")}  to="/settings/shop/currencies" id="settings-shop-currencies"><SettingsCurrencies /><span>Currencies</span></NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/shop/cart")}  to="/settings/shop/cart" id="settings-shop-cart"><SettingsCart /><span className="d-flex align-items-center justify-content-start">Shopping Cart</span></NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/shop/subscription")}  to="/settings/shop/subscription" id="settings-shop-subscription"><SettingsSubs /><span className="d-flex align-items-center justify-content-start">Subscriptions</span></NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/shop/design")}  to="/settings/shop/design" id="settings-shop-design"><SettingsDesign /><span>Design</span></NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/shop/managers")}  to="/settings/shop/managers" id="settings-shop-managers"><SettingsManagers /><span>Managers</span></NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/shop/fraud")}  to="/settings/shop/fraud" id="settings-shop-fraud"><SettingsFraud /><span>Fraud</span></NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/shop/gateway-fees")}  to="/settings/shop/gateway-fees" id="settings-shop-gateway-fees"><SettingsGatewayFees /><span>Gateway Adjustments</span></NavLink>
				<NavLink activeClassName="active" onClick={onChangeRoute.bind(this, "/settings/shop/affiliate")}  to="/settings/shop/affiliate" id="settings-shop-affiliate"><CustomersAffiliate /><span>Affiliate</span></NavLink>
			</div>
		</div>

		<ClosePage to={closeConfirmModal} open={closeConfirmModal} close={() => setShowConfirmModal(false)} />

	</div>
}

export default Sidebar;
